
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';

// Add base meta tags that should be available on initial page load
document.head.innerHTML += `
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <meta name="description" content="Future Level - KI-generierte Videos für Social Media und Produktpräsentationen">
  <meta name="keywords" content="KI-Videos, AI Video, Videomarketing, Social Media Ads, Produktvideos">
  <meta name="author" content="Future Level">
  <link rel="icon" type="image/x-icon" href="/favicon.ico">
  
  <!-- Social Media Tags -->
  <meta property="og:site_name" content="Future Level">
  <meta property="og:image" content="https://future-level.ch/opengraph-image-p98pqg.png">
  <meta property="og:type" content="website">
  <meta name="twitter:card" content="summary_large_image">
  
  <!-- Mobile Specific Meta Tags -->
  <meta name="apple-mobile-web-app-capable" content="yes">
  <meta name="apple-mobile-web-app-status-bar-style" content="black-translucent">
  <meta name="theme-color" content="#1A1F2C">
  
  <!-- Language Tags - Swiss Regional Codes -->
  <link rel="alternate" hreflang="de-CH" href="https://www.future-level.ch/de">
  <link rel="alternate" hreflang="fr-CH" href="https://www.future-level.ch/fr">
  <link rel="alternate" hreflang="it-CH" href="https://www.future-level.ch/it">
  <link rel="alternate" hreflang="en-CH" href="https://www.future-level.ch/en">
  <link rel="alternate" hreflang="x-default" href="https://www.future-level.ch/de">
`;

createRoot(document.getElementById("root")!).render(<App />);
